import Vue from 'vue'
import { GetterTree, MutationTree, ActionTree } from 'vuex'
import { arrayUnion, arrayRemove } from 'vuex-easy-firestore'

import _find from 'lodash/find'
import _sample from 'lodash/sample'

import { IImage } from '@/models'

class State {
    _images: Array<IImage> = []
    _imagesSeen: Array<IImage> = []
    _currentImage: IImage | undefined | null = null
}

const getters = {
    images( state ) {
        return state._images
    },

    currentImage( state ) {
        return state._currentImage
    },

    imageById( state ) {
        return ( id: string ) => _find( state._images, { id: id } )
    },

    totalImages( state ) {
        return Object.keys( state._images ).length
    }
} as GetterTree<State, any>

const mutations = {
    setCurrentImage( state, id: string ) {
        const currentImage = id ? _find( state._images, { id: id } ) : _sample( state._images )

        Vue.set( state, '_currentImage', currentImage )
    },

    setImages( state, images: Array<IImage> ) {
        state._images = images
    }
} as MutationTree<State>

const actions = {
    setRelatedAssociation( { state, dispatch }, associationId: string ) {
        if ( state._currentImage ) {
            const imageAssociations = state._currentImage.relatedAssociations

            if ( imageAssociations.indexOf( associationId ) === -1 ) {
                dispatch( 'patch', {
                    id: state._currentImage.id,
                    relatedAssociations: arrayUnion( associationId )
                } )
            }
        }
    },
    removeRelatedAssociation( { state, dispatch }, associationId: string ) {
        if ( state._currentImage ) {
            const imageAssociations = state._currentImage.relatedAssociations
            const associationIndex = imageAssociations.indexOf( associationId )

            if ( associationIndex !== -1 ) {
                dispatch( 'patch', {
                    id: state._currentImage.id,
                    relatedAssociations: arrayRemove( associationId )
                } )
            }
        }
    }
} as ActionTree<State, any>

const ImagesModule = {
    firestorePath: 'Images',
    firestoreRefType: 'collection',
    moduleName: 'imagesModule',
    statePropName: '_images',
    namespaced: true,
    state: new State(),
    mutations,
    getters,
    actions
}

export default ImagesModule